<div class="uber-setting-panel">
  <h5 class="panel-title">Uber BackFill settings</h5>
  <p class="panel-help">
    Controls when a booking is offered from Uber instead of Moniic supply.
  </p>
  <p class="panel-note" *ngIf="!isLoading && !isConfigured">
    Not configured yet — using service defaults.
  </p>

  <div class="form-group">
    <label class="toggle-label" for="uberBackfillEnabled">
      <input
        id="uberBackfillEnabled"
        type="checkbox"
        [(ngModel)]="isEnabled"
        name="isEnabled"
        [disabled]="isLoading || isSaving"
      />
      <span>Uber BackFill enabled</span>
    </label>
    <p class="field-help">
      When off, no new Uber bookings are created. Trips already booked on Uber
      are not affected.
    </p>
  </div>

  <div class="form-group">
    <label for="pickupEtaThresholdMinutes">Pickup ETA threshold (minutes)</label>
    <input
      id="pickupEtaThresholdMinutes"
      type="number"
      class="form-control threshold-input"
      [min]="minThreshold"
      [max]="maxThreshold"
      step="1"
      [(ngModel)]="pickupEtaThresholdMinutes"
      name="pickupEtaThresholdMinutes"
      [disabled]="isLoading || isSaving"
    />
    <p class="field-error" *ngIf="!isThresholdValid">
      Enter a whole number between {{ minThreshold }} and {{ maxThreshold }}.
    </p>
    <p class="field-help">
      Moniic is always preferred when its nearest chauffeur is within this many
      minutes.
    </p>
  </div>

  <div class="form-group">
    <label for="assignmentStrategy">Assignment strategy</label>
    <select
      id="assignmentStrategy"
      class="form-control strategy-select"
      [(ngModel)]="assignmentStrategy"
      name="assignmentStrategy"
      [disabled]="isLoading || isSaving"
    >
      <option *ngFor="let option of strategyOptions" [ngValue]="option.value">
        {{ option.label }}
      </option>
    </select>
    <p class="field-help">{{ selectedStrategy.help }}</p>
  </div>

  <p class="panel-updated" *ngIf="updatedAt">
    Last updated {{ updatedAt | date: "dd MMM yyyy, hh:mm a" }}
  </p>

  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!canSave"
    (click)="saveSetting()"
  >
    {{ isSaving ? "Saving..." : "Save" }}
  </button>
</div>
